var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3AutoManual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 53a2 2 0 01-2 2H52v2h14a2 2 0 010 4H52v2h10a2 2 0 010 4H46.13a14.002 14.002 0 01-10.121-23.808A14 14 0 0145.87 39H54a2 2 0 010 4h-9v2h21a2 2 0 010 4H52v2h18a2 2 0 012 2zM11 28.74A16.56 16.56 0 0143.68 25h-5.37l7.81 8.47L53.93 25h-6.17a20.56 20.56 0 10-21.62 24.26h1.41v-4h-1.14A16.6 16.6 0 0111 28.74zM25.86 18h4.27l7.64 20h-3.55l-1.73-5h-9.15l-1.8 5h-3.43l7.75-20zm2 3.71L24.73 30h6.36l-3.23-8.29z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Auto-manual.20d1ab7c.svg";
export { SvgJ3AutoManual as ReactComponent };